import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../Common/Pagination/Pagination";
import CountUp from "react-countup";
import { useReactToPrint } from "react-to-print";
const PrivateOrderStatus = ({ selectedDate, companyDetails }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [status, setStatus] = useState("true");
  const [pageSize, setPageSize] = useState(10);
  const [statusOrder, setStatusOrder] = useState([]);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + statusOrder?.length - 1, totalRecords);
  const [companyId, setCompanyId] = useState("");
  const [privateCountData, setPrivateCountData] = useState([]);
  const [filterCriteria, setfilterCriteria] = useState({
    party_name: "",
    po_number: "",
    di_number: "",
  });

  const componentPDF = useRef();
  const handlePrintBulk = useReactToPrint({
    content: () => componentPDF.current,
    pageStyle: `
      @page {
        size: auto !important;
      }
      @media print {
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.9);
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
        }
      }`,
    documentTitle: "Private Order Status",
  });
  const getPrivateOrderCount = async () => {
    const renewalDate = moment(selectedDate).format("YYYY-MM-DD");
    let BASE_URL =
      SERVER_URL +
      `/api/order-status/private-order-status-count/${user_id}?date=${renewalDate}&companyId=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setPrivateCountData(result.data);
    } else {
      setPrivateCountData([]);
    }
  };
  useEffect(() => {
    getPrivateOrderCount();
  }, [companyId, selectedDate]);
  const getOrderStatusData = async () => {
    const currentQueryDate = moment(selectedDate).format("YYYY-MM-DD");
    const BASE_URL = `${SERVER_URL}/api/order-status/private-order-status-report/${user_id}?date=${currentQueryDate}&companyId=${companyId}&take=${pageSize}&skip=${
      currentPage - 1
    }&party_name=${filterCriteria.party_name}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setStatusOrder(result.data);
    } else {
      setStatusOrder([]);
    }
  };

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };

  useEffect(() => {
    getOrderStatusData();
  }, [currentPage, pageSize, selectedDate, companyId, filterCriteria]);
  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };
  return (
    <>
      <div className="card mt-4">
        <div className="card-body">
          <div>
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <p className="card-title">Private Orders</p>
              <div style={{ display: "flex" }}>
                <select
                  className="form-control ml-2"
                  onChange={handleCompanyChange}
                  value={companyId}
                >
                  <option value="">Select Company (All)</option>
                  {companyDetails &&
                    companyDetails?.length > 0 &&
                    companyDetails?.map((item, id) => {
                      return (
                        <option
                          key={id}
                          value={item.id}
                        >{`${item.companyName}, ${item.location}`}</option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi mdi-account-credit-card menu-icon mr-4 icon-lg dashboard-icon`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Total Orders</small>
                    <h2>
                      <CountUp
                        end={privateCountData?.totalCount}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-4">
        <div className="card-body">
          {/* <div className="search mb-3 mt-3">
            <div className="row justify-content-end">
              <div className="col-md-2">
                <div className="form-group">
                  <select
                    className="form-control ml-2"
                    onChange={handleCompanyChange}
                    value={companyId}
                  >
                    <option value="">Select Company (All)</option>
                    {companyDetails?.map((item, id) => {
                      return (
                        <option
                          key={id}
                          value={item.id}
                        >{`${item.companyName}, ${item.location}`}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div> */}
          <div className="status_heading">
            <h5>
              Private Order Status As On Date:{" "}
              {moment(selectedDate).format("DD-MM-YYYY")}
            </h5>
          </div>
          <div className="row">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="col-md-4">
                <div className="form-group flex-grow-1 me-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by party name"
                    id="party_name"
                    name="party_name"
                    onChange={(e) =>
                      handleFilterChange("party_name", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div>
              {/* <div className="col-md-4">
                <div className="form-group flex-grow-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by PO number"
                    id="order_number"
                    name="po_number"
                    onChange={(e) =>
                      handleFilterChange("po_number", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div> */}
              {/* <div className="col-md-4">
                <div className="form-group flex-grow-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by DI number"
                    id="order_number"
                    name="di_number"
                    onChange={(e) =>
                      handleFilterChange("di_number", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div> */}
            </div>
            {/* <div className="col-md-6">
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-sm btn-primary print_btn"
                  type="button"
                  disabled={
                    statusOrder && statusOrder?.length > 0 ? false : true
                  }
                  onClick={() => handlePrintBulk()}
                >
                  Print All
                  <i
                    className="mdi mdi-printer-eye"
                    style={{ fontSize: "20px" }}
                  ></i>
                </button>
              </div>
            </div> */}
          </div>

          <p>
            <span className="print_btn d-flex justify-content-end">
              <i
                className="mdi mdi-printer-eye"
                style={{ fontSize: "25px" }}
                onClick={() =>
                  statusOrder && statusOrder?.length > 0
                    ? handlePrintBulk()
                    : null
                }
              ></i>
            </span>
          </p>

          <div className="tkcs-table-container">
            <div
              className="table-responsive table-bordered govt-table"
              style={{
                border: "0.05px solid lightGray",
                width: "auto",
                marginTop: "20px",
              }}
              ref={componentPDF}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Company Name</th>
                    <th>Party Name</th>
                    <th>Date</th>
                    <th>Received Date</th>
                    <th>Size</th>
                    <th>Order Qty</th>
                    <th>Rate</th>
                    <th>Order Value</th>
                    <th>Order Value With GST</th>
                    <th>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {statusOrder &&
                    statusOrder?.length > 0 &&
                    statusOrder?.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item.company_name}</td>
                            <td>{item.party_name}</td>
                            <td>{item.date}</td>
                            <td>{item.received_date}</td>
                            <td>{item.size}</td>
                            <td>{item.order_qty}</td>
                            <td>{item.rate}</td>
                            <td>{item.cost}</td>
                            <td>{item.cost_with_gst}</td>
                            <td>{item.remark}</td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default PrivateOrderStatus;
